// This file was automatically generated from appchart.visitNote.labsProblemsDialog.html.
// Please don't edit this file by hand.

goog.provide('el8.template.appchart.visitNote.labsProblemsDialog');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.visitNote.labsProblemsDialog.content = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8DialogContainer"><span class="feature-available-container">');
  el8.template.appchart.visitNote.labsProblemsDialog.available(null, output);
  output.append('</span><span class="feature-unavailable-container"></span></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.visitNote.labsProblemsDialog.available = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="spacer"><p class="el8AppColor">Choose one or more of the reports below and Elation will analyze and pre-populate the relevant lab results and problems from the patient\'s problem list into the visit note:</p></div><div class="feed-container el8FeedContainer"></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.visitNote.labsProblemsDialog.unavailable = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="overlayContainer"><p class="el8ExtraLargeFontSize el8ColorText">Automatically match lab results to problems in your Problem List and automatically place them into your visit note.</p><div class="spacer"></div><p class="el8LargeFontSize">To use this feature, please add the following to your chart:</p><ol class="spacer">', (opt_data.noIcd9s) ? '<li class="el8BulletLargeText">ICD-9 codes after at least one problem in the Problem List on the left hand side of the Patient Chart. <span class="el8AppText">To insert ICD-9 codes after a problem, simply click on that problem and in the small screen that appears, type in the ICD-9 code or ICD-9 description in the ICD-9 field.</span><div class="spacer"></div></li>' : '', (opt_data.noLabs) ? '<li class="el8BulletLargeText">Lab reports with some digitalized lab data in the chart that the feature can recognize. <span class="el8AppText">Currently, this capacity is limited to Quest or MuirLab reports that have been received electronically (but not by fax).</span><div class="spacer"></div></li>' : '', '</ol></div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.visitNote.labsProblemsDialog.feed = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<ol id="', soy.$$escapeHtml(opt_data.listId), '" class="el8ReportList"></ol><div class="systemNoteContainer">Note: Labs since last visit are pre-selected.</div><div class="moreFeedContainer"><button id="labs-problems-more-btn" class="el8button moreFeed">More</button></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.visitNote.labsProblemsDialog.labReport = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<li id="', soy.$$escapeHtml(opt_data.feedId), '" class="feed-item el8ReportListItem el8ItemHover ', (! opt_data.isSignedOff) ? ' el8NewItem' : '', '"><div class="el8ItemButtonContainer"><button class="el8button view-trigger el8ItemButton" _fid="', soy.$$escapeHtml(opt_data.feedItemId), '">View</button></div><span class="el8CheckboxWrap"><input type="checkbox" _fid="', soy.$$escapeHtml(opt_data.feedItemId), '" /></span><span class="feed-item-indicator"></span><span class="leftIndent">', (soy.$$escapeHtml(opt_data.documentDate)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.documentDate)) : ''), '</span><span class="item-description-text leftIndent">', (! opt_data.isSignedOff) ? '** NEW ** ' : '', soy.$$escapeHtml(opt_data.description), (opt_data.abnormalResultsStr) ? ' (<span class="el8AttentionText">' + soy.$$escapeHtml(opt_data.abnormalResultsStr) + '</span>)' : '', '</span>', (opt_data.cardSummary != null) ? '<span class="leftIndent el8StandardFontSize el8AppColor">' + soy.$$escapeHtml(opt_data.cardSummary) + '</span>' : '', '</li>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.visitNote.labsProblemsDialog.alreadySelected = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<span class="el8TagItem mr5">Prev. Selected</span>');
  if (!opt_sb) return output.toString();
};
